import type { OnInit } from '@angular/core';
import { Component, computed, inject, input } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxButtonComponent, OnyxInputLabelComponent } from '@onyx/angular';
import { omit } from 'lodash';
import { ValidationHelper } from '../../../../../common/helpers/validation.helper';
import type { ValidationGroup } from '../../../../../common/interfaces/validation/validation-group';
import { OrderFormRestorePointType } from '../../../common/enums/order-form-cancel-action-type';
import type { OrderLoadingPointFormGroup } from '../../../common/helpers/order-form.helper';
import { OrderFormHelper } from '../../../common/helpers/order-form.helper';
import type { OrderFormGood } from '../../../common/interfaces/order-form-good';
import { OrderFormService } from '../../../common/services/order-form.service';
import { OrderPointBaseFormComponent } from '../order-point-form/order-point-base-form/order-point-base-form.component';
import { OrderPointInformationFormComponent } from '../order-point-form/order-point-information-form/order-point-information-form.component';
import { OrderLoadingPointGoodFormComponent } from './order-loading-point-good-form/order-loading-point-good-form.component';

@Component({
  selector: 'app-order-loading-point-form',
  imports: [
    OrderPointBaseFormComponent,
    OnyxInputLabelComponent,
    TranslatePipe,
    ReactiveFormsModule,
    OrderLoadingPointGoodFormComponent,
    OnyxButtonComponent,
    OrderPointInformationFormComponent,
  ],
  templateUrl: './order-loading-point-form.component.html',
  styleUrl: './order-loading-point-form.component.scss',
})
export class OrderLoadingPointFormComponent implements OnInit {
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly orderFormService = inject(OrderFormService);

  public readonly form = input.required<OrderLoadingPointFormGroup>();
  public readonly goods = input.required<OrderFormGood[]>();
  public readonly disabled = input.required<boolean>();
  public readonly parametersValidation = input.required<
    ValidationGroup | undefined
  >();
  public readonly isCompleted = input.required<boolean>();

  protected readonly I18N = 'orders.orderForm.points.loadingPoint';

  protected goodsFormArray = computed(() => this.form().controls.goods);

  public ngOnInit(): void {
    if (!this.disabled()) return;

    ValidationHelper.disableControls(
      Object.values(omit(this.form().controls, 'goods')),
      { reset: false },
    );
  }

  protected addGood(): void {
    this.goodsFormArray().push(
      OrderFormHelper.buildLoadingPointGoodForm(this.fb),
    );
  }

  protected removeGood(index: number): void {
    this.orderFormService.addRestorePoint(
      OrderFormRestorePointType.REMOVED_GOOD,
    );
    this.goodsFormArray().removeAt(index);
    if (!this.goodsFormArray().length) this.addGood();
  }
}
